<template>
  <filter-base
    :is-loading="loading"
    @close="$emit('close')"
    @reset-filter="
      resetFilter().then(() => {
        $emit('update')
      })
    "
  >
    <template #skeleton>
      <v-skeleton-loader v-for="index in 4" :key="index" class="mt-2" type="list-item" />
    </template>
    <template #filter>
      <search-filter-input
        v-for="filterNode in filters"
        :key="filterNode.name"
        :filter-node="filterNode"
        :get-selection-for-filter="getSelectionForFilter"
        :update-filter-selection="updateFilterSelection"
        :remove-item-from-filter-selection="removeItemFromFilterSelection"
        :filter-event="trackFilterFunction"
        :multiple="false"
        @update="$emit('update')"
      />
    </template>
  </filter-base>
</template>

<script lang="ts">
import FilterBase from '@/components/filter/FilterBase.vue'
import SearchFilterInput from '@/components/filter/SearchFilterInput.vue'
import useQuotesFilter from '@/modules/quote/useQuotesFilter'
import FilterEvent from '@/modules/tracking/events/filter'
import { storeToRefs } from 'pinia'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'QuoteFilter',
  components: { SearchFilterInput, FilterBase },
  emits: ['close', 'update'],
  setup() {
    const { filters, loading } = storeToRefs(useQuotesFilter())
    const resetFilter = useQuotesFilter().resetFilter
    const getSelectionForFilter = useQuotesFilter().getSelectionForFilter
    const updateFilterSelection = useQuotesFilter().updateFilterSelection
    const removeItemFromFilterSelection = useQuotesFilter().removeItemFromFilterSelection

    const trackFilterFunction = FilterEvent.GetFor('quotes')('Default')

    return {
      filters,
      loading,
      resetFilter,
      getSelectionForFilter,
      updateFilterSelection,
      removeItemFromFilterSelection,
      trackFilterFunction
    }
  }
})
</script>
